import React from 'react';
import CampaignTypeSection from './ProjectTypeSections/CampaignTypeSection';

/**
 *
 * @typedef {{}} CampaignsSideMenuProps
 * @type {React.FC<CampaignsSideMenuProps>}
 */

const CampaignsSideMenu = ({ onNavigate }) => {
  const types = ['image', 'video', 'social'];
  return (
    <>
      {types.map((type, idx) => {
        const id = `${type}-${idx}`;
        return (
          <React.Fragment key={id}>
            <CampaignTypeSection type={type} onNavigate={onNavigate} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CampaignsSideMenu;
